import { type Logger } from './types';

// For requests that are not mission critical
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export const monitorErrorsOnRequest = (request: IDBRequest, logger: Logger): void => {
	request.onerror = (event) => {
		logger.warn('Error thrown from request:', event);
	};
};
